module.exports = __webpack_public_path__ + "img/goodsB4.75219d59.png";